﻿import {isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import {Message} from "@2d-front-monorepo/design-library";
import {
	getHiddenDriverProperties,
	getHiddenResidencyProperties, getHiddenVehicleProperties,
	Permits,
	ResidencyUses
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

import {JSX} from "react";
import {useParams} from "react-router";
import {PermitsBackButtonFrame} from "../../components/PermitsBackButton";
import {useGlobalContext} from "../../hooks/useGlobalContext";
import {usePermits} from "../../hooks/usePermits";
import PermitListComponent from "./ViewComponents/PermitListComponent";

export default function PermitsGroup(): JSX.Element {
	const {permits, holderData} = usePermits();
	const {groupName} = useParams();
	const installation = useGlobalContext();
	const filtered = Permits.getFilteredPermits(permits.permits, groupName!);

	if (isNullOrEmpty(groupName)) {
		return <Message title={{text: "Missing group name"}} type="error"/>;
	}

	return (
		<>
			<h1>{translation(PermitTranslations.summary_page__title)}</h1>
			<hr/>
			<PermitListComponent
				holderData={holderData}
				permits={permits}
				grouped={filtered}
				now={installation.now}/>

			<PermitsBackButtonFrame/>
		</>
	);
}
